<ng-container *ngIf="!isListView; else listView">
  <ng-container [ngSwitch]="type">
    <mat-form-field class="fill" *ngSwitchCase="ConfigValueType.String">
      <input
        [readonly]="
          (variant === ConfigEditorDetailVariant.Edit && !editValueAccess) ||
          (variant === ConfigEditorDetailVariant.New && !configFunctionsAccess)
        "
        matInput
        trim="blur"
        data-testid="config-editor-value-input-text"
        type="text"
        autocomplete="off"
        [formControl]="formControl"
      />
    </mat-form-field>
    <mat-form-field *ngSwitchCase="ConfigValueType.Number">
      <input
        [readonly]="
          (variant === ConfigEditorDetailVariant.Edit && !editValueAccess) ||
          (variant === ConfigEditorDetailVariant.New && !configFunctionsAccess)
        "
        matInput
        trim="blur"
        data-testid="config-editor-value-input-number"
        type="number"
        autocomplete="off"
        [formControl]="formControl"
      />
    </mat-form-field>
    <mat-form-field *ngSwitchCase="ConfigValueType.Integer">
      <input
        [readonly]="
          (variant === ConfigEditorDetailVariant.Edit && !editValueAccess) ||
          (variant === ConfigEditorDetailVariant.New && !configFunctionsAccess)
        "
        matInput
        trim="blur"
        data-testid="config-editor-value-input-integer"
        type="number"
        step="1"
        autocomplete="off"
        [formControl]="formControl"
      />
    </mat-form-field>
    <div *ngSwitchCase="ConfigValueType.Boolean" class="select-wrapper">
      <mat-form-field>
        <mat-select
          [formControl]="formControl"
          [disabled]="
            (variant === ConfigEditorDetailVariant.Edit && !editValueAccess) ||
            (variant === ConfigEditorDetailVariant.New && !configFunctionsAccess)
          "
        >
          <mat-option [value]="true"> TRUE </mat-option>
          <mat-option [value]="false"> FALSE </mat-option>
        </mat-select>
      </mat-form-field>
    </div>
  </ng-container>
</ng-container>

<ng-template #listView>
  <div class="d-flex flex-column">
    <div class="d-flex align-items-center mb-3 w-100" *ngFor="let control of arrayControl.controls">
      <ng-container [ngSwitch]="type">
        <mat-form-field class="fill" *ngSwitchCase="ConfigValueType.String">
          <input
            matInput
            [readonly]="
              (variant === ConfigEditorDetailVariant.Edit && !editValueAccess) ||
              (variant === ConfigEditorDetailVariant.New && !configFunctionsAccess)
            "
            trim="blur"
            data-testid="config-editor-list-value-input-text"
            type="text"
            autocomplete="off"
            [formControl]="control"
          />
        </mat-form-field>
        <mat-form-field *ngSwitchCase="ConfigValueType.Number">
          <input
            [readonly]="
              (variant === ConfigEditorDetailVariant.Edit && !editValueAccess) ||
              (variant === ConfigEditorDetailVariant.New && !configFunctionsAccess)
            "
            matInput
            trim="blur"
            data-testid="config-editor-list-value-input-number"
            type="number"
            autocomplete="off"
            [formControl]="control"
          />
        </mat-form-field>
        <mat-form-field *ngSwitchCase="ConfigValueType.Integer">
          <input
            [readonly]="
              (variant === ConfigEditorDetailVariant.Edit && !editValueAccess) ||
              (variant === ConfigEditorDetailVariant.New && !configFunctionsAccess)
            "
            matInput
            trim="blur"
            data-testid="config-editor-list-value-input-integer"
            type="number"
            step="1"
            autocomplete="off"
            [formControl]="control"
          />
        </mat-form-field>
        <div *ngSwitchCase="ConfigValueType.Boolean" class="select-wrapper">
          <select
            [formControl]="formControl"
            [disabled]="
              (variant === ConfigEditorDetailVariant.Edit && !editValueAccess) ||
              (variant === ConfigEditorDetailVariant.New && !configFunctionsAccess)
            "
          >
            <option [value]="true">True</option>
            <option [value]="false">False</option>
          </select>
          <svg-icon key="down"></svg-icon>
        </div>
      </ng-container>
      <span class="icon ml-2" (click)="removeElement(control)">
        <svg-icon key="trash"></svg-icon>
      </span>
    </div>
    <div class="d-flex">
      <span class="icon row-start-center" (click)="addElement()">
        <svg-icon key="plus"></svg-icon>
        <span data-testid="config-editor-add-list-value-icon" class="pl-1">Add</span></span
      >
    </div>
  </div>
</ng-template>
